import { Stack } from "@mui/material";
import HelpButton from "../HelpButton";
import {
  SimpleTableDialogExplainSection,
  SimpleTableDialogReference,
  SimpleTableDialogTableSection,
} from "./commons/SimpleTableHelpDialog";

export default function SASRiskDialog() {
  return (
    <HelpButton dialogTitle="睡眠時無呼吸症候群のリスク">
      <Stack gap={6}>
        <SimpleTableDialogExplainSection
          title="判定の仕組み"
          content="パルスオキシメーターにより測定したODI3の結果から睡眠時無呼吸症候群のリスクを判定しています。"
        />
        <SimpleTableDialogExplainSection
          title="ODI3とは"
          content="酸素飽和度がベースラインから3%以上下がった回数／時間を示します。睡眠中に呼吸が止まると酸素飽和度が下がるため、その回数が多ければ多いほど睡眠時無呼吸症候群の疑いが強くなります。SLEEP COMPASSではODI3が5以上の場合に「リスクあり」として表示しています。"
        />
        <SimpleTableDialogTableSection
          title="ODI3の重症度"
          records={[
            ["ODI3の値", "重症度"],
            ["1未満", "睡眠呼吸障害のリスクは非常に低いです"],
            ["1 ≦ ODI3 ＜ 5", "睡眠呼吸障害のリスクは低いです"],
            ["5 ≦ ODI3 ＜ 15", "睡眠呼吸障害のリスクが中程度です"],
            ["15 ≦ ODI3 ＜ 30", "睡眠呼吸障害のリスクが高いです"],
            ["30以上", "睡眠呼吸障害のリスクが非常に高いです"],
          ]}
        />
        <SimpleTableDialogReference>
          2023 年改訂版
          循環器領域における睡眠呼吸障害の診断・治療に関するガイドライン
        </SimpleTableDialogReference>
      </Stack>
    </HelpButton>
  );
}
